import styled from 'styled-components'

export const UserActionsWrapper = styled.div`
  display: flex;
  position: relative;
  justify-content: flex-end;
`

export const UserActionsButton = styled.button`
  display: flex;
  border: 0;
  padding: 0;
  font-size: 1.25rem;
  color: #999999;
  background-color: white;
  :hover {
    color: #1f1f1f;
  }
`
export const UserActionButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const UserActionMenu = styled.div`
  position: absolute;
  top: 1.75rem;
  z-index: 1;
  border: 2px solid #666666;
  border-radius: 5px;
  background-color: ${props => (props.useGrayBackground ? '#f1f1f1' : 'white')};
  padding: 0 1rem;
`

export const UserActionMenuItem = styled.div`
  border: 0;
  padding: 0.438rem 0rem;
  background-color: white;
  display: flex;
  width: 100%;
  white-space: nowrap;
  :not(:last-child) {
    border-bottom: 1px solid #666666;
  }
`

export const ActionLink = styled.a`
  transition: none;
  font-family: Molde-regular;
  text-decoration: none !important;
  cursor: pointer;
  color: ${props =>
    props.type === 'remove' ? '#D0021B' : '#25282A'} !important;
  :hover {
    font-weight: 600;
    color: ${props =>
      props.type === 'remove' ? '#e1523d' : '#25282A'} !important;
  }
`



// WEBPACK FOOTER //
// ./src/components/UserActions/component.styles.js